<template>
    <div class="panel-item row" v-if="news">
        <div class="col-12 col-lg-4">
            <router-link :to="newsPath(news)">
                <img v-lazy="image" class="img-thumbnail"/>
            </router-link>
        </div>
        <div class="col-12 col-lg-8">
            <h4><router-link :to="newsPath(news)">{{news.title}}</router-link></h4>
            <small>{{news.updated_at | formatTime}}</small>
        </div>
    </div>
</template>

<script>
  import newsMixin from '../../mixins/newsMixin';
  import {replacePathImageForSmall} from "../../utils/images";

  export default {
    name: 'SidePanelPreview',
    props: ['news'],
    mixins: [newsMixin],
    computed: {
      image() {
        return replacePathImageForSmall(this.news.image);
      }
    }
  };
</script>

<style scoped>

</style>
